<template>
  <div class="breadcrumb-item">
    <div v-for="item in itemList" :key="item.path" @click="toPath(item)" :class="{ clickable: item.path }">
      <span>{{ item.name || item }}</span>
      <span class="separator">/</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'breadcrumb-item',
  props: {
    itemList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  methods: {
    toPath (item) {
      if (item.path)
      {
        return this.$router.push(item.path)
      }
      if (item.back)
      {
        return this.$router.back()
      }
    }
  }
}
</script>
<style lang="scss">
.breadcrumb-item {
  display: flex;
  align-items: item;
  font-size: 18px;
  margin: 20px auto;

  span {
    color: #727272;

  }

  .separator {
    margin: 0 9px;
    color: #727272;
  }

  div:last-child {
    .separator {
      display: none;
    }

    span {
      color: #2d2d2d;
    }
  }
  .clickable{
    cursor: pointer;
  }
  .clickable:hover span {
    color: #0E9560;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/breadcrumbItem/index.vue